import { render, staticRenderFns } from "./room-product.vue?vue&type=template&id=919af618&scoped=true&"
import script from "./room-product.vue?vue&type=script&lang=js&"
export * from "./room-product.vue?vue&type=script&lang=js&"
import style0 from "./room-product.vue?vue&type=style&index=0&id=919af618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919af618",
  null
  
)

export default component.exports